import {
	Component, ViewEncapsulation,
	OnInit, OnDestroy, OnChanges,
	Input, trigger, state, transition, style, animate
} from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Observable, BehaviorSubject } from 'rxjs/Rx';

// Interfaces
import { IComponent, IApplicationModel, IApplication, IReviewer, IReviewerModel } from '../../interfaces';
// Models
import { ApplicationModel } from '../../classes';

//Enums
import { RoleEnum, MessageTypeEnum, ApplicationStatusEnum } from '../../enums';
// Services
import * as Srv from '../../services';

@Component({
	selector: 'app-assign-reviewers',
	templateUrl: './assign-reviewers.component.html',
	styleUrls: ['./assign-reviewers.component.scss'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('marginChanged', [
			state('shown', style({ opacity: 1, height: '100px' })),
			state('hidden', style({ opacity: 0, height: "0" })),
			transition('shown=>hidden', animate('1s'))
		])
	],
})
export class AssignReviewersComponent implements
	IComponent, OnInit, OnChanges, OnDestroy {
	// implements IComponent interfaces
	name = 'AssignReviewersComponent';
	subscriptions: Subscription[] = [];
	reviewerFLname = '';

	// implements local variables
	//@Input() APPLICATIONMODEL: IApplicationModel;
	APPLICATIONMODEL: IApplicationModel;
	reviwerHover: IReviewer;
	isReviwerHoverHidden = 'hidden';
	RoleEnum: typeof RoleEnum = RoleEnum;

	constructor(
		private _loggerService: Srv.LogService,
		private _loaderService: Srv.LoaderService,
		private _dialogService: Srv.DialogService,
		public _applicationService: Srv.ApplicationService,
		public _userSrv: Srv.UserService,
		private _helperSrv: Srv.HelperService,
		private _msgSrv: Srv.MessageService,
		private _voteService: Srv.VoteService,
		private _reviewerService: Srv.ReviewerService,
	) {

		this.subscriptions.push(
			this._reviewerService.REVIEWERS.subscribe(r => {
				this._loggerService.Debug(this.name, ['updating Reviewers', r]);
				if (r) {
					this._update(undefined);
				}
			})
		);

		// this.subscriptions.push(
		//   this._reviewerService.PANELS.subscribe(r => {
		//     this._loggerService.Debug(this.name, ['updating Panels', r]);
		//   })
		// );

		// this.subscriptions.push(
		//   this._reviewerService.BOARDS.subscribe(r => {
		//     this._loggerService.Debug(this.name, ['updating boards', r]);
		//   })
		// );


	}


	ngOnInit() {

		this.subscriptions.push(
			this._applicationService.APPLICATIONMODEL.subscribe(a => {
				//this._loggerService.Debug(this.name, ['updating detail resolver', d]);
				this.APPLICATIONMODEL = a;
				if (a) {
					this._loaderService.SetLoading(this.name, true);
					this._reviewerService.GetReviewers(this.APPLICATIONMODEL.Application.Id).subscribe(r => {
						// "Updating reviewers".logWithObject(this.name, r);
						this._loaderService.SetLoading(this.name, false);
					}, err => {
						this._loggerService.Error(this.name, ['Unable to get reviewers', err]);
						this._loaderService.SetLoading(this.name, false);
					});
				}
			})
		);
	}

	ngOnChanges() {

	}

	ngOnDestroy() {
		this.subscriptions.forEach(s => {
			s.unsubscribe();
		});
		delete this.subscriptions;
		this._loggerService.Debug(this.name, ['updating ngOnDestroy']);

	}

	OnClose() {
		this._reviewerService.SelectPanelDialogOpen = false;
	}

	OnSave() {
		this._loggerService.Debug(this.name, ['saving']);

		let app: IApplicationModel = this.APPLICATIONMODEL;

		let qc = this._reviewerService.Reviewers.filter(r => r.Reviewer.PositionId === RoleEnum.QC);
		let panels = this._reviewerService.Reviewers.filter(r => r.Reviewer.PositionId === RoleEnum.Panel);
		let board = this._reviewerService.Reviewers.filter(r => r.Reviewer.PositionId === RoleEnum.Board);


		let qcSelected = qc.filter(p => p.Reviewer.Selected === true);
		let boardSelected = board.filter(p => p.Reviewer.Selected === true);
		let panelsSelected = panels.filter(p => p.Reviewer.Selected === true);


		// get selected qc

		if (this._reviewerService._updateStatusTo >= ApplicationStatusEnum.QC_Review || this.APPLICATIONMODEL.Application.Status >= ApplicationStatusEnum.QC_Review) {
			if (qcSelected.length != 1) {
				this._msgSrv.DisplayLocalMessage(this.name,
					{
						isError: true,
						message: 'Please select 1 QC Reviewer',
						type: MessageTypeEnum.ohsnap
					});
				return;
			}
		}

		//Panels
		if (this._reviewerService._updateStatusTo >= ApplicationStatusEnum.Panel_Review || this.APPLICATIONMODEL.Application.Status >= ApplicationStatusEnum.Panel_Review) {
			// if (panelsSelected.length != 1 && app.Application.NeedsSiteReview) {
			// 	this._msgSrv.DisplayLocalMessage(this.name,
			// 		{
			// 			isError: true,
			// 			message: 'Please select 1 Panel Reviewer',
			// 			type: MessageTypeEnum.ohsnap
			// 		});
			// 	return;
			// }



			if (panelsSelected.length != 2) {
				this._msgSrv.DisplayLocalMessage(this.name,
					{
						isError: true,
						message: 'Please select 2 Panel Reviewers',
						type: MessageTypeEnum.ohsnap
					});
				return;
			}



			// get selected boards

			if (boardSelected.length < 2) {
				this._msgSrv.DisplayLocalMessage(this.name,
					{
						isError: true,
						message: 'Please select at least 2 Board Reviewers',
						type: MessageTypeEnum.ohsnap
					});
				return;
			}
		}





		// get selected members



		this._loaderService.SetLoading(this.name, true);
		// this._loggerService.Debug(this.name, ['posting reviewers', this._reviewerService.PostingReviewers]);


		let contactIds: string[] = [];
		// check for duplicates
		this._reviewerService.PostingReviewers.forEach(r => {
			if (contactIds.find(c => c === r.Reviewer.ContactId)) {
				// we have a duplicate


				this._msgSrv.DisplayLocalMessage(this.name,
					{
						isError: true,
						message: 'You have selected ' + r.Reviewer.Fullname + ' multiple times.',
						type: MessageTypeEnum.ohsnap
					});

			}
			contactIds.push(r.Reviewer.ContactId);
		});

		if (contactIds.length === this._reviewerService.PostingReviewers.length) {
			this.subscriptions.push(
				this._reviewerService.PostReviewers(app).subscribe(reviewers => {

					this._loggerService.Debug(this.name, ['posted reviewers', reviewers]);




					this._msgSrv.DisplayLocalMessage(this.name,
						{
							isError: false,
							message: 'Your selections have been saved',
							type: MessageTypeEnum.welldone
						});

					setTimeout(() => {

						if (this._reviewerService._updateStatusTo == ApplicationStatusEnum.Panel_Review || this._reviewerService._updateStatusTo == ApplicationStatusEnum.QC_Review) {
							this._reviewerService.AssignToPanels$.emit({
								value: 'PANEL',
								tag: 'AssigntoPanel',
								text: '',
								header: 'Assign to Panel',
								calleer: this.name
							});
						}


						this._loaderService.SetLoading(this.name, false);
						this._reviewerService.SelectPanelDialogOpen = false;

					}, 1500);

				}, err => {
					this._loggerService.Error(this.name, ['error posting reviewers', err]);
					this._loaderService.SetLoading(this.name, false);

					this._msgSrv.DisplayLocalMessage(this.name,
						{
							isError: true,
							message: 'System was not able to save your selections',
							type: MessageTypeEnum.ohsnap
						});

				}));
		} else {
			this._loggerService.Error(this.name, ['System was not able to verify if there are any duplicates among selected members']);
		}




	}



	onMouseOver(x: IReviewer) {
		x.Hover = 'block';
		this.reviwerHover = x;
		this.isReviwerHoverHidden = 'shown';
		// console.log(this.reviwerHover);
	}

	onMouseOut(x: IReviewer) {
		x.Hover = 'none';
		this.isReviwerHoverHidden = 'hidden';

		// console.log(this.reviwerHover);
	}

	onCheckBoxClicked(x: IReviewerModel, e: any) {
		this._loaderService.SetLoading(this.name, true);
		x.Reviewer.Selected = e.checked;




		setTimeout(() => {
			this._update(x);
			this._loaderService.SetLoading(this.name, false);

			//this._loggerService.Debug(this.name, ['updating posting reviewers', this._reviewerService.PostingReviewers]);

		}, 100);

	}

	private _update(x) {

		if (x) {
			this._reviewerService.Reviewers.filter(r => r.Reviewer.PositionId === x.Reviewer.PositionId && r.Reviewer.ContactId == x.Reviewer.ContactId)[0].Reviewer.Selected = x.Reviewer.Selected;
		}

		if (this._reviewerService.Reviewers && this._reviewerService.Reviewers.length > 0) {

			let panels = this._reviewerService.Reviewers.filter(r => r.Reviewer.PositionId === RoleEnum.Panel);
			let boards = this._reviewerService.Reviewers.filter(r => r.Reviewer.PositionId === RoleEnum.Board);

			// get selected members
			let panelsSelected = panels.filter(p => p.Reviewer.Selected === true);
			let boardsSelected = boards.filter(b => b.Reviewer.Selected === true);


			this._loggerService.Debug(this.name, ['Updating the checkboxes', panels, boards, panelsSelected, boardsSelected]);
			// limit panels to only two
			if (panelsSelected.length >= 2) {
				// console.log('panels', panelsSelected.length);
				let panelUnselected = panels.filter(p => p.Reviewer.Selected === false);
				panelUnselected.forEach(p => p.Reviewer.Disabled = true);
				panelsSelected.forEach(p => {
					let brd = boards.find(b => b.Reviewer.ContactId === p.Reviewer.ContactId);
					if (brd) {
						brd.Reviewer.Disabled = true;
						brd.Reviewer.Selected = false;
					}
				});
			} else {
				panels.forEach(p => {
					if (boardsSelected.find(b => b.Reviewer.ContactId === p.Reviewer.ContactId)) {
						p.Reviewer.Disabled = true;
						p.Reviewer.Selected = false;
					} else {
						p.Reviewer.Disabled = false;
					}
				});
			}

			if (x) {
				// check for duplcity
				let others = this._reviewerService.Reviewers.filter(r => r.Reviewer.ContactId === x.Reviewer.ContactId && r.Reviewer.PositionId !== x.Reviewer.PositionId);
				if (others) {
					if (x.Reviewer.Selected === true) {
						others.forEach(o => {
							o.Reviewer.Selected = false;
							o.Reviewer.Disabled = true;
						});
					} else {
						others.forEach(o => {
							if (o.Reviewer.PositionId === RoleEnum.Board) {
								o.Reviewer.Disabled = false;
							} else if (panelsSelected.length < 2) {
								o.Reviewer.Disabled = false;
							}
						});
					}
				}



			}
		}
	}
}



// WEBPACK FOOTER //
// C:/AZURE/ACEP/Acep.Crm.WebPortal/CrmWebPortalGlobal/Membership/AngularApps/PACED/PACEDAngular/src/app/share/components/assign-reviewers/assign-reviewers.component.ts